import React, { Component, useRef, useState, useEffect } from 'react';
import {Link, useParams } from "react-router-dom";
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';
import * as utils from '../common/Utils.js'
import { useConfig } from '../contexts/ConfigContext.js';

import { collection, query, where, getDoc, getDocs, setDoc, updateDoc, doc, Timestamp } from "firebase/firestore";
import { db } from '../firebase.js';

const DATABASE_SOURCE = utils.getDatabaseSource();

const AdminSignedUpPlayers = () => {
  const { playerID } = useParams();
  const config = useConfig();
  const CURRENT_SEASON = config.currentSeason;
  const [signups, setSignups] = useState([]);
  const [allSignups, setAllSignups] = useState([]);
  const [players, setPlayers] = useState([]);
  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    if (!config.configLoaded) return;
    getPlayers();
    getSignups();
  }, [config.configLoaded, CURRENT_SEASON]) // eslint-disable-line react-hooks/exhaustive-deps

  const getPlayers = async () => {
    const playerSnapshot = await getDocs(collection(db, 'players'));
    const players = []
    playerSnapshot.forEach((doc) => {
      const player = doc.data()
      players.push(player)
    });

    setPlayers(players);
  }

  const getSignups = async () => {
    const signupsSnapshot = await getDocs(collection(db, "signups"));
    const signups = []

    // Used this code to add paid: true to all signups
    // signupsSnapshot.forEach(async (docSnapshot) => {
    //   const signupRef = doc(db, "signups", docSnapshot.id);
    //   await updateDoc(signupRef, { paid: true });
    // });

    signupsSnapshot.forEach((doc) => {
      const id = doc.id
      const signup = doc.data()
      signup.id = id
      signups.push(signup)
    });

    setAllSignups(signups)

    const thisSeasonSignups = signups.filter((signup) => signup.season == CURRENT_SEASON)

    let signupsSortedNewestToOldest = thisSeasonSignups.sort(function(s1,s2){
      let s1_date = new Date(s1.created_at.seconds * 1000 + s1.created_at.nanoseconds / 1000000)
      let s2_date = new Date(s2.created_at.seconds * 1000 + s2.created_at.nanoseconds / 1000000)
      return s2_date - s1_date;
    })
    setSignups(signupsSortedNewestToOldest)
    setDataReady(true);
  }

  function getPlayerByPlayerID (playerID) {
    return players.find((player) => player.id == playerID)
  }

  function displayPlayerNameRow (player, place=0) {
    return (
      <div className='league-player-list-player'>
        <p key={player.id + '-player-name'}>{ place + 1 }. <a className="unstyled-link" href={"/players/" + player.id }>{ utils.displayPlayerName(player) }</a></p>
      </div>
    )
  }

  async function togglePaid (player, signup) {
    let playerCheckbox = 'paidCheckbox-' + player.id
    let checkbox = document.getElementById(playerCheckbox)

    try {
      const signupsCollection = await collection(db, "signups");
      const q = query(signupsCollection, where("player_id", "==", signup.player_id), where("season", "==", signup.season));

      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        // Update the paid attribute for the first matching document
        const docSnapshot = querySnapshot.docs[0];
        const signupRef = doc(db, "signups", docSnapshot.id);
        await updateDoc(signupRef, { paid: checkbox.checked });
    } else {
        console.warn(`No document found for player ID: ${signup.player_id}, season: ${signup.season}`);
      }
    } catch (error) {
      console.error(error)
    }
  }

  function displayPlayer (player, place=0, showJustName=false, signup) {
    if (!player) {
      return (
        <div>
          <p>error with signup</p>
          <p>player: { JSON.stringify(player) }</p>
          <p>signup: { JSON.stringify(signup) }</p>
        </div>
      )
    }

    if (showJustName) {
      return (
        <div className='league-player-list-player'>
          <div>
            <p className={ 'league-player-' + signup.status } key={player.id + '-player-name'}>{ place + 1 }. <a className="unstyled-link" href={"/players/" + player.id }>{ utils.displayPlayerName(player) }</a></p>
            <p>Email: { player.email }</p>
            <p>Phone: { player.phone }</p>
            <p>Height: { player.height.feet }' { player.height.inches }"</p>
            <p>Birthday: { player.birthday.month }/{ player.birthday.day }/{ player.birthday.year }</p>
            <p>Jersey Size: { player.jerseySize}</p>
            <p>Player ID: { player.id }</p>
            <p>Signup ID: { signup.id }</p>
          </div>
          <div>
            <div className='mb-3 admin-edit-col centered-edit-col'>
              <label className="form-check-label">
                Paid?
              </label>
              <input className="form-check-input big-checkbox" type="checkbox" value="" id={"paidCheckbox-" + player.id} defaultChecked={ signup.paid } onClick={ () => { togglePaid(player, signup) }}/>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <>
          <p className="league-title-standard-secondary text-align-center">Welcome to League Morning Star!</p>
          <a className="league-type league-mini-header-link" href="/">View Homepage</a>
          <h4 className='text-align-center'>New Player</h4>
          <p>Name: { player.first_name } { player.last_name }</p>
          <p>Email: { player.email }</p>
          <p>Phone: { player.phone }</p>
          <p>Height: { player.height.feet }' { player.height.inches }"</p>
        </>
      )
    }
  }

  function copyUnpaidEmails () {
    let unpaidSignups = signups.filter((s) => s.paid == false)
    let unpaidSignupPlayers = unpaidSignups.map((s) => getPlayerByPlayerID(s.player_id))
    const emails = unpaidSignupPlayers.map(player => player?.email?.trim()).filter(Boolean).join(', ');

    navigator.clipboard.writeText(emails)
    .then(() => {
      alert('Emails copied to clipboard!');
    })
    .catch(err => {
      console.error('Failed to copy emails: ', err);
    });
  }

  // Uses signups already loaded on page load so the clipboard write happens
  // within the click (browsers can block it after an awaited fetch).
  function copyRecentPlayerEmails () {
    const lastSeasonSignups = allSignups.filter((signup) => signup.season == parseInt(CURRENT_SEASON) - 1)
    const emails = [...new Set(
      lastSeasonSignups
        .map((signup) => getPlayerByPlayerID(signup.player_id)?.email?.trim())
        .filter(Boolean)
    )].join(', ');

    if (!emails) {
      alert('No emails found for last season.');
      return;
    }

    navigator.clipboard.writeText(emails)
    .then(() => {
      alert('Emails copied to clipboard!');
    })
    .catch(err => {
      console.error('Failed to copy emails: ', err);
      alert('Failed to copy emails.');
    });
  }

  // Every email from every player record, regardless of season
  function copyAllHistoricalPlayerEmails () {
    const emails = [...new Set(
      players.map((player) => player?.email?.trim()).filter(Boolean)
    )].join(', ');

    if (!emails) {
      alert('No player emails found.');
      return;
    }

    navigator.clipboard.writeText(emails)
    .then(() => {
      alert('Emails copied to clipboard!');
    })
    .catch(err => {
      console.error('Failed to copy emails: ', err);
      alert('Failed to copy emails.');
    });
  }

  function copyEmails () {
    let signupPlayers = signups.map((signup) => getPlayerByPlayerID(signup.player_id))
    const emails = signupPlayers.map(player => player?.email?.trim()).filter(Boolean).join(', ');

    navigator.clipboard.writeText(emails)
    .then(() => {
      alert('Emails copied to clipboard!');
    })
    .catch(err => {
      console.error('Failed to copy emails: ', err);
    });
  }

  function showOldPlayersNotSignedUp () {
    const seasonPlayerIDs = signups.map((signup) => signup.player_id)
    const allPlayerIDs = players.map((player) => player.id)
    const notReturningPlayerIDs = allPlayerIDs.filter(p => !seasonPlayerIDs.includes(p))

    return (
      <>
        { notReturningPlayerIDs.map((playerID, place) => displayPlayerNameRow(getPlayerByPlayerID(playerID), place))}
      </>
    )
  }

  const generateCSVWithNamesAndJerseySize = () => {
    const headers = ['Name', 'Jersey Size'];
    const newPlayers = signups.filter((s) => s.status === 'new')
    const rows = newPlayers.map(s => {
      let p = utils.getPlayerByID(players, s.player_id)

      return [
        utils.displayPlayerName(p),
        p.jerseySize
      ]
    }).sort((a, b) => a[0].localeCompare(b[0]));

    let csvContent = headers.join(',') + '\n';
    rows.forEach(row => {
      csvContent += row.join(',') + '\n';
    });


    return csvContent;
  }

  const generateCSVWithNamesAndPaid = () => {
    const headers = ['Name', 'Paid?'];
    const rows = signups.map(s => [
      utils.displayPlayerName(utils.getPlayerByID(players, s.player_id)),
      s.paid
    ]).sort((a, b) => a[0].localeCompare(b[0]));

    let csvContent = headers.join(',') + '\n';
    rows.forEach(row => {
      csvContent += row.join(',') + '\n';
    });

    return csvContent;
  }

  const generateCSVWithNamesAndContactInfo = () => {
    const headers = ['Name', 'Email', 'Phone'];
    const paidSignUps = signups.filter((s) => s.paid)
    const signedUpPlayers = paidSignUps.map((signup) => utils.getPlayerByID(players, signup.player_id))
    const rows = signedUpPlayers.map(player => [utils.displayPlayerName(player), player.email, player.phone]);

    let csvContent = headers.join(',') + '\n';
    rows.forEach(row => {
      csvContent += row.join(',') + '\n';
    });

    return csvContent;
  }

  const generateCSVWithNamesAndHeights = () => {
    const headers = ['Name', 'Height'];
    const signedUpPlayers = signups.map((signup) => utils.getPlayerByID(players, signup.player_id))
    const rows = signedUpPlayers.map(player => [utils.displayPlayerName(player), utils.displayPlayerHeight(player)]);

    let csvContent = headers.join(',') + '\n';
    rows.forEach(row => {
      csvContent += row.join(',') + '\n';
    });

    return csvContent;
  };

  const downloadNewNamesWithJerseySize = () => {
    const csvData = generateCSVWithNamesAndJerseySize();
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'new_players.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const downloadNamesWithPaid = () => {
    const csvData = generateCSVWithNamesAndPaid();
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'players.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const downloadNamesAndContactInfo = () => {
    const csvData = generateCSVWithNamesAndContactInfo();
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'players.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const downloadNamesAndHeights = () => {
    const csvData = generateCSVWithNamesAndHeights();
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'players.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function displayAllPlayers () {
    let paidSignUps = signups.filter((signup) => signup.paid === true)

    let newSignUps = signups.filter((signup) => signup.status === 'new')
    let newPlayers = newSignUps.map((signup) => utils.getPlayerByID(players, signup.player_id))

    let newPaidSignUps = signups.filter((signup) => signup.status === 'new' && signup.paid === true)
    let newPaidPlayers = newPaidSignUps.map((signup) => utils.getPlayerByID(players, signup.player_id))

    return (
      <>
        <p className="league-title-standard-secondary text-align-center">{ signups.length } Signed Up Player{ signups.length < 2 ? '' : 's' } ({ newPlayers.length } new)</p>
        <p className="league-title-standard-secondary text-align-center">{ paidSignUps.length } Paid Player{ paidSignUps.length < 2 ? '' : 's' } ({ newPaidPlayers.length } new)</p>

        <button className="btn btn-dark" type="button" onClick={copyEmails}>Copy All Player Emails</button>
        <button className="btn btn-dark" type="button" onClick={copyRecentPlayerEmails}>Copy All Last Season Player Emails</button>
        <button className="btn btn-dark" type="button" onClick={copyAllHistoricalPlayerEmails}>Copy All Historical Player Emails</button>
        <button className="btn btn-dark" type="button" onClick={copyUnpaidEmails}>Copy Unpaid Player Emails</button>
        <button className="btn btn-dark" type="button" onClick={downloadNamesAndContactInfo}>Download Names and Contact Info</button>
        <button className="btn btn-dark" type="button" onClick={downloadNamesAndHeights}>Download Names and Heights</button>
        <button className="btn btn-dark" type="button" onClick={downloadNamesWithPaid}>Download Names Alphabetically with Paid</button>
        <button className="btn btn-dark" type="button" onClick={downloadNewNamesWithJerseySize}>Download New Players with Jersey Size</button>

        <div className="league-flex-accordion-container">
          <div class="accordion accordion-flush league-accordion" id="accordionExample">
            <div class="accordion-item league-accordion-item">
              <h2 class="accordion-header league-accordion-header" id="headingOne">
                <button class="accordion-button league-accordion-button collapsed league-title-skinny-small-extended-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Old Players Not Yet Signed Up
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body league-accordion-body">
                  <div className="league-table-container schedule scroll-on-overflow">
                    { showOldPlayersNotSignedUp() }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p>Jersey Sizes for new players - Format: Total (Paid)</p>
        <div className='league-jersey-count'>
          <p>S: { newPlayers.filter((player) => player && player.jerseySize == 'S').length} ({ newPaidPlayers.filter((player) => player.jerseySize == 'S').length})</p>
          <p>M: { newPlayers.filter((player) => player && player.jerseySize == 'M').length} ({ newPaidPlayers.filter((player) => player.jerseySize == 'M').length})</p>
          <p>L: { newPlayers.filter((player) => player && player.jerseySize == 'L').length} ({ newPaidPlayers.filter((player) => player.jerseySize == 'L').length})</p>
          <p>XL: { newPlayers.filter((player) => player && player.jerseySize == 'XL').length} ({ newPaidPlayers.filter((player) => player.jerseySize == 'XL').length})</p>
          <p>2XL: { newPlayers.filter((player) => player && player.jerseySize == 'XXL').length} ({ newPaidPlayers.filter((player) => player.jerseySize == 'XXL').length})</p>
        </div>

        { signups.map((signup, place) => displayPlayer(getPlayerByPlayerID(signup.player_id), place, true, signup))}
      </>
    )
  }

  if (dataReady == false) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Schedule">
        <div className="league-content">

          <div className="league-body">
            <p className='league-admin-back-button'><a className='league-link' href="/admin"><b>← Back to Admin Home</b></a></p>
            <div className="dropdown league-dropdown">
            </div>
            <div className="league-table-container schedule">
              {
                playerID ?
                displayPlayer(getPlayerByPlayerID(playerID), true)
                :
                displayAllPlayers()
              }
              { playerID ? '' : ''
              //displayAllPlayersEmails()
              }
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default AdminSignedUpPlayers;
